export function apply() { // eslint-disable-line import/prefer-default-export
  Number.isNaN = Number.isNaN || function checkNumber(value) {
    // eslint-disable-next-line
    return typeof value === 'number' && isNaN(value)
  }
}
